import React from 'react';

import ClientRole from '/component/partial/report/ClientRole';
import ClientsListHeader from '/component/partial/report/ClientsListHeader';
import ExpiringRewards from '/component/partial/report/ExpiringRewards';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';

import {ReportProps} from '../Report.types';
import {generateOnRecordPress} from '../report.util';

import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

export const ClientsExpiringRewardsContent = ({
  loadingData = {total: 0}, // Default value for loadingData
  showRecordPopover = () => {},
  recordsShowPopover = () => {},
  recordsShowRecord = () => {},
}: ReportProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  if (!isReadyToLoad) {
    return null;
  }
  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: ClientsListHeader,
        personRoleComponent: ClientRole,
        personInfoComponent: ExpiringRewards,
        onRecordPress: generateOnRecordPress({
          showRecordPopover,
          recordsShowPopover,
          recordsShowRecord,
        }),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
